enum DashboardType {
  Unknown = "Unknown",
  Project = "Project",
  Employee = "Employee",
  Admin = "Admin",
  NYSDOHAdHocProject = "NYSDOHAdHocProject",
  Directory = "Directory",
  CACDI = "CACDI",
  NJDMAHS = "NJDMAHS",
  NetworkAssessment = "NetworkAssessment",
  AccessReports = "AccessReports",
  Operations = "Operations",
  NetworkOutreach = "NetworkOutreach",
  ComplianceConnect = "ComplianceConnect",
}

enum RoleType {
        Unknown = "unknown",
        /// <summary>
        /// Roles available for assigning to any user
        /// </summary>
        Public = "public", 
        /// <summary>
        /// Roles available for assignment to any "internal" user (Quest client login, "-t" or ResourceAdmin guest login)
        /// </summary>
        InternalUseOnly = "internalUseOnly", 
        /// <summary>
        /// Roles available for assignment to Quest Client users only
        /// </summary>
        QuestClientOnly = "questClientOnly",
}

export { DashboardType, RoleType };
